import { z } from "zod";

export const RtCurrencyCode = z.enum([
  "GBP",
  "EUR",
  "USD",
  "CAD",
  "AUD",
  "AED",
]);
